var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 494,
    height: 531,
    viewBox: "0 0 494 531",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.00001C0 3.58173 3.58172 0 8 0H413.883C458.065 0 493.883 35.8172 493.883 80V522.508C493.883 526.926 490.301 530.508 485.883 530.508H80C35.8172 530.508 0 494.69 0 450.508V8.00001Z",
    fill: "#FFCD03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBg);
export default __webpack_public_path__ + "static/media/img-bg.99725db9d5215fa0eeb1b51b11683ed3.svg";
export { ForwardRef as ReactComponent };